export default "__VITE_ASSET__eZ_juH58__"